export default "__VITE_ASSET__COATqQMO__"